module.exports = __webpack_public_path__ + "assets/img/dzh-25.bd6d1eec.jpg";